
//
// Ajax Batch Job Report
//
// Refresh the little job report thingie every second or two.
//

module.exports = function AjaxBatchJobReport ($host, config) {

  // Config
  var endpoint     = config.endpoint;
  var pollInterval = 1;

  // Dom
  var $title = $('[data-job-title]', $host);
  var $text  = $('[data-job-text]',  $host);
  var $icon  = $('[data-job-icon]',  $host);

  // State
  var state = { timer: { cancel: id } };

  // Functions
  function cancel () {
    clearInterval(state.timer);
  }

  function refresh () {
    fetchJson(endpoint, function (report) {
      onResponseAvailable(report);
      if (report && report.status !== 'finished') {
        state.timer = delay(pollInterval, refresh);
      } else {
        state.timer.cancel();
        reloadPage();
      }
    }, log);
  }

  function onResponseAvailable (report) {
    log(report, report.job);
    if (report) {
      log('AjaxBatchJobReport::onResponseAvailable - job report received (' + report.status + ')');
      update(report);
    } else {
      log('AjaxBatchJobReport::onResponseAvailable - no job report. Job finished, presumably.');
    }
  }

  function update (report) {
    $title.text(report.title);
    $text.html(report.text);
    $host.addClass(report.state);
    $icon.get(0).src = report.icon;
  }


  // Ajax
  state.timer = delay(pollInterval, refresh);

  // Interface
  return {
    stop: cancel
  }

};

